import React, { useState } from "react";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import Widget from "./Widget";
import { useSelector } from "react-redux";
import { Backdrop, Box, CircularProgress, useMediaQuery } from "@mui/material";
import { useTheme } from "@emotion/react";

dayjs?.extend(customParseFormat);

const WIDGET_BAR_HEIGHT = 140;

const SalonWidget = ({
  dynamicPosition,
  widgetSetupId,
  buttonPosition,
  widgetPosition,
  floating,
}) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const { widgetConfig, buttonText } = useSelector((store) => store?.widgetSettings);
  const { widgetSettings } = useSelector((store) => store.salon);

  const hasImage            = Boolean(widgetSettings?.settings?.imageFileName?.trim());
  const configuredImgHeight = widgetSettings?.settings?.imageHeight;

  const [height, setHeight] = useState(WIDGET_BAR_HEIGHT);

  const handleHeight = (newHeight) => {

    if (!hasImage) setHeight(newHeight);
  };
  const iframeHeight = hasImage
    ? configuredImgHeight
      ? `${configuredImgHeight}px`
      : "100vh"
    : `${height}px`;

  const send = (frameHeight, frameWidth, top, right, bottom, left, floating, redirectUrl) => {
    window.parent.postMessage(
      {
        reservationIframeHeight: frameHeight,
        reservationIframeWidth: frameWidth,
        reservationIframePositionTop: top,
        reservationIframePositionRight: right,
        reservationIframePositionBottom: bottom,
        reservationIframePositionLeft: left,
        reservationIframePositionFloating: floating,
        redirectUrl: redirectUrl,
      },
      "*"
    );
  };

  // ── kiosk mode ────────────────────────────────────────────────────────────
  if (widgetConfig?.settings?.kioskMode) {
    return (
      <Box sx={{ width: "100%", minHeight: "100vh" }}>
        <Widget
          heightChange={handleHeight}
          dynamicPosition={dynamicPosition}
          widgetSetupId={widgetSetupId}
          buttonPosition={buttonPosition}
          widgetPosition={widgetPosition}
          floating={floating}
        />
      </Box>
    );
  }

  return (
    <>
      {send(iframeHeight, "100vw", "0px", "0px", "0px", "", floating)}
      <Box
        sx={{
          width: "100%",
          height: iframeHeight,
          position: "relative",
          overflow: "visible",
        }}
      >
        <Widget
          heightChange={handleHeight}
          dynamicPosition={dynamicPosition}
          widgetSetupId={widgetSetupId}
          buttonPosition={buttonPosition}
          widgetPosition={widgetPosition}
          floating={floating}
        />
      </Box>
    </>
  );
};

export default SalonWidget;
